import React from 'react';
import Calendar from 'react-calendar';
import moment from 'moment';

class MenuWeekPicker extends React.Component {
  render() {
    const value = this.getWeekOf(this.props.value);
    return (
      <Calendar
        value={value}
        calendarType="US"
        minDetail="year"
        onChange={this.handleClickDay}
        onClickDay={this.handleClickDay}
        minDate={this.props.isEdit ? this.getWeekOf(new Date())[0] : null}
        formatMonthYear={(_, value) => moment(value).format('MMM YYYY')}
      />
    );
  }

  handleClickDay = value => {
    // check if isEdit ...weird hack
    if (!this.props.isEdit) {
      this.props.updateMenu({ service_week: this.props.value });
      return;
    }

    const week = this.getWeekOf(value);
    const service_week = moment(week[0]).format('YYYY-MM-DD');
    this.props.updateMenu({ service_week });
  };

  getWeekOf(value) {
    if (!value) return null;
    const sunday = moment(value)
      .startOf('week')
      .toDate();
    const saturday = moment(value)
      .endOf('week')
      .toDate();
    return [sunday, saturday];
  }
}
export default MenuWeekPicker;



// WEBPACK FOOTER //
// ./src/components/menu/MenuWeekPicker.js